import {
  AddressSchema,
  InvoiceBirthdateSchema,
  InvoiceSchema,
  ValidationUtils,
} from '@ca/common'
import { getAppRegion } from 'storage/useRemoteConfigParams'
import { z } from 'zod'

const validateVat = (v?: string) => {
  const region = getAppRegion()
  if (!v) {
    return region.vat !== 'required'
  }
  return ValidationUtils.vat.validate(v, region.code)
}

export const AddressVatSchema = AddressSchema.extend({
  vat: z.string().refine(validateVat, 'invalidVAT'),
})

export const InvoiceVatIdSchema = InvoiceSchema.extend({
  vatId: z.string().optional().refine(validateVat, 'invalidVAT'),
})

export const InvoiceFormSchema = InvoiceVatIdSchema.omit({
  birth_date: true,
})
  .extend({
    birth_date: InvoiceBirthdateSchema.nullable(),
  })
  .superRefine((data, ctx) => {
    if (!data.birth_date) {
      ctx.addIssue({
        code: 'custom',
        message: 'required',
        path: ['birth_date'],
      })
    }
  })
